import Hero from './Hero';
import HowDoesEpcBuilderWork from './HowDoesEpcBuilderWork';
import ImpactSection from './ImpactSection';
import InstallationMeasures from './InstallationMeasures';
import PersonalisedReport from './PersonalisedReport';
import Testimonials from './Testimonials';
import WhatMakesUsDifferent from './WhatMakesUsDifferent';

export {
  Hero,
  HowDoesEpcBuilderWork,
  ImpactSection,
  InstallationMeasures,
  PersonalisedReport,
  Testimonials,
  WhatMakesUsDifferent,
};
